import { useMemo } from 'react'
import IconPhysics from '@ucheba/ui/icons/icon__atom.svg'
import IconMathematics from '@ucheba/ui/icons/icon__math.svg'
import IconRussian from '@ucheba/ui/icons/icon__russian.svg'
import IconInformatics from '@ucheba/ui/icons/icon__mouse.svg'
import IconSocial from '@ucheba/ui/icons/icon__socium.svg'
import IconGeography from '@ucheba/ui/icons/icon__geo.svg'
import IconEnglish from '@ucheba/ui/icons/icon__english.svg'
import IconChemistry from '@ucheba/ui/icons/icon__chimstery.svg'
import IconLiterature from '@ucheba/ui/icons/icon__pero.svg'
import IconHistory from '@ucheba/ui/icons/icon__history.svg'
import IconBiology from '@ucheba/ui/icons/icon__dnk.svg'
import IconForeignlanguage from '@ucheba/ui/icons/icon__lang-message.svg'
import { p11n } from '@ucheba/utils/helpers/string'
import { EModColorBgText } from '@ucheba/utils/helpers/styles/mod.types'
import { getParsedCookies } from '@ucheba/utils/helpers/core'
import { programTypeCookie } from '../../pages/for-abiturients/planner/constants'

export const getProgramType = (): string => {
  const cookieType = getParsedCookies()[programTypeCookie]
  return cookieType || '1002'
}

export const getTextForSimilar = (
  count: number | null | undefined,
  total: number,
  selectedTotal: number
): string => {
  const programType = getProgramType()
  if (total === selectedTotal) return ''

  if (!count)
    return `В этом ${
      programType === '1001' ? 'колледже' : 'вузе'
    } можно подать документы на другие программы. `

  const num = (count > total ? total : count) - selectedTotal

  if (num === 0) {
    return ''
  }

  if (num < 0) {
    return `<span style="color: #fe2f80">В этом вузе можно подать документы только на ${count} ${p11n(
      count,
      'программу',
      'программы',
      'программ'
    )}.</span>`
  }

  return `В этом ${
    programType === '1001' ? 'колледже' : 'вузе'
  } можно подать документы еще на ${num} ${p11n(
    num,
    'программу',
    'программы',
    'программ'
  )}. `
}

export const showButton = (total: number, selectedTotal: number): boolean => {
  return selectedTotal < total
}

interface IUseProgramListItemCore {
  (): {
    icons: {
      [key: string]: any
    }
  }
}

export const useProgramListItemCore: IUseProgramListItemCore = () => {
  const icons = useMemo(() => {
    return {
      mathematics: IconMathematics,
      russian: IconRussian,
      informatics: IconInformatics,
      foreignlanguage: IconForeignlanguage,
      social: IconSocial,
      physics: IconPhysics,
      geography: IconGeography,
      english: IconEnglish,
      chemistry: IconChemistry,
      literature: IconLiterature,
      history: IconHistory,
      biology: IconBiology,
    }
  }, [])

  return {
    icons,
  }
}

export const showAlsoButtonText = (total: number, isTouch?: boolean): string => {
  if (isTouch) {
    if (total === 1) {
      return `Показать еще ${total} программу`
    }
    return `Показать еще ${total} программ`
  }

  if (total === 1) {
    return `Показать еще ${total} подходящую программу`
  }
  return `Показать еще ${total} подходящих программ`
}

interface IProbability<T = never> {
  txt: string
  color: keyof typeof EModColorBgText | T
}
export const useProbability = (num: number | null | undefined): IProbability | null => {
  if (num) {
    if (num < 50) return { txt: 'низкие шансы', color: 'rose50' }
    if (num < 90) return { txt: 'средние шансы', color: 'yellow' }
    if (num >= 90) return { txt: 'высокие шансы', color: 'lime' }
  }

  return null
}

export const isPriceDurationText = (programType: number): string => {
  const programTypeValues = [1000, 21, 22, 23, 24, 1001, 11, 12, 1002, 1, 2, 3, 4]

  const isNotCourse = programTypeValues.includes(programType)

  if (isNotCourse) {
    return 'за год'
  }

  return 'за курс'
}
